import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';
import 'typeface-raleway';
// A custom theme for this app
const theme = (primary) => createMuiTheme({
  typography: {
      fontFamily: 'Raleway, Arial',
  },
  palette: {
    primary: {
      main: primary,
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
  },
  overrides: {
    MuiCard: {
      root: {
        borderColor: primary

      }
    },
    MuiToggleButton: {
      root: {
        '&$selected': {
          color: primary,
          backgroundColor: "transparent",
        },        
      }
    },
    MuiTab: {
      root: {
        '&:last-child': {
          backgroundColor: primary
        }
      }
    }
  }
});

export default theme;